import { combineReducers } from "redux";
import commonReducer from "../../../../Common/Reducers/commonReducer";
import drivingMarketParamsReducer from "../drivingMarketsParams";
import HighestLoser from "./highestLoser";
export default combineReducers({
    reducersData: HighestLoser,
    commonData: commonReducer,
    paramsData: drivingMarketParamsReducer,
});
